module.exports = "<md-toolbar class=\"md-hue-2\">\n  <div class=\"md-toolbar-tools\">\n    <h2><i class=\"fa fa-redo\"></i>&nbsp;端末再起動</h2>\n  </div>\n</md-toolbar>\n\n<div class=\"sa-reboot-content\">\n  <h3>{{ $ctrl.company.name }}</h3>\n\n  <div class=\"sa-reboot-list\">\n    <md-toolbar class=\"md-hue-2\">\n        端末一覧\n    </md-toolbar>\n\n    <div class=\"sa-reboot-item\" ng-repeat=\"device in $ctrl.devices\">\n      <sa-reboot-item device=\"device\"></sa-reboot-item>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/dev/app/sa_reboot/oem/sa_reboot.html
// module id = 960
// module chunks = 0